import React from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Layouts/Sidebar";
import Header from "./Layouts/Header";
import { API_ENDPOINTS } from "../../../config/api";

const VolunteerDashboard = () => {
  const location = useLocation();
  const { uid } = useParams();
  const [status, setStatus] = React.useState(localStorage.getItem("userStatus") || "pending");

  React.useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.USERS.DISPLAY(uid));
        if (response.ok) {
          const data = await response.json();
          if (data && data.status && data.status !== status) {
            localStorage.setItem("userStatus", data.status);
            sessionStorage.setItem("userStatus", data.status);
            setStatus(data.status);

            toast.info(`Your account approval status has been updated to: ${data.status.toUpperCase()}`, {
              position: "top-right",
              autoClose: 5000,
            });
          }
        }
      } catch (err) {
        console.error("Error polling user status:", err);
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 5000);
    return () => clearInterval(interval);
  }, [uid, status]);

  React.useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage, {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [location.state]);

  return (
    <div className="admin-dashboard-wrapper admin-db1" style={{ display: 'flex', minHeight: '100vh', overflow: 'hidden' }}>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', marginLeft: '250px' }}>
        <Header />
        <div className="main-content db1-bg" style={{ flex: 1, overflowY: 'auto', marginTop: '60px', padding: 0 }}>
          <Outlet />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default VolunteerDashboard;
